import { css } from '@emotion/react'
import { useState } from 'react'
import { inject, Observer } from 'mobx-react'

import { withRouterProps } from '../../../utils'
import { Loading } from '../../../components'
import Button from '../../../components/Button'
import { ButtonGroup } from '../elements/styled'

// TO-DO: Change managed account text to point-in-time advice based on templateId
function ImplementChangesButtons({ navigate, store, offboarding }) {
  const [state, setState] = useState('idle')

  // Do this check in case they get to this page through the back button when they've already submitted a transaction
  if (offboarding.acceptedCaseSubmitted) {
    handleNext()
  }

  function handleNext() {
    navigate(`/implement/${offboarding.nextRoute('implement-changes')}`)
  }

  async function acceptManagedAccount() {
    try {
      setState('loading')

      const { acceptedContributionDistribution, updateAcceptedCase } = store

      await updateAcceptedCase(
        acceptedContributionDistribution.catchUp ? acceptedContributionDistribution : null
      )
      offboarding.setAcceptedCaseSubmitted(true)

      handleNext()
    } catch (err) {
      console.error(err)
      setState('error')
    }
  }

  function render() {
    if (state === 'loading') {
      return (
        <ButtonGroup>
          <Loading />
        </ButtonGroup>
      )
    }

    const { features } = store

    return (
      <div>
        {state === 'error' && (
          <div
            css={css`
              color: crimson;
              text-align: center;
            `}>
            Oops! Something went wrong, please try again later
          </div>
        )}
        <ButtonGroup>
          <Button variant='secondary' type='button' onClick={() => navigate('/overall')}>
            Cancel
          </Button>

          {features.managedAccountAvailable && (
            <Button variant='primary' type='button' onClick={() => acceptManagedAccount()}>
              Implement changes
            </Button>
          )}
        </ButtonGroup>
      </div>
    )
  }

  return <Observer>{render}</Observer>
}

export default withRouterProps(inject('store', 'offboarding')(ImplementChangesButtons))
